module.exports = __webpack_public_path__ + "static/media/1-4-adp9Bwg9.304bd6d6.mp3";